module.exports = __webpack_public_path__ + "static/img/wallpaper-mb4.8fe93f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wallpaper-mb4.jpg
// module id = ZRa+
// module chunks = 1